import * as ActionTypes from 'state/types'
import { Session } from 'shared/utils/storage'
import { sortByName } from 'shared/utils/array'

const findLanguage = () => {
  let profile

  try {
    profile = Session.hasItem('profile')
      && JSON.parse(Session.getItem('profile'))
  } catch (err) {
    console.error('Session reducer :: Failed to parse profile', err)
  }

  if(profile && profile.language) {
    return profile.language
  }
  return 'en'
}


const initialState = {
  isRequesting: false,
  isAuthenticated: false,
  token: null,
  hasOrganisations: false,
  organisations: [],
  profile: null,
  language: findLanguage()
}

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ActionTypes.PROFILE_REQUEST}_START`: {
      return {
        ...state,
        isRequesting: true,
        hasOrganisations: false,
        organisations: [],
        profile: null
      }
    }

    case `${ActionTypes.PROFILE_REQUEST}_SUCCESS`: {
      const {
        profile,
        organisations
      } = action.response.payload

      const hasOrganisations = (organisations && !!organisations.length)

      return {
        ...state,
        isRequesting: false,
        organisations: organisations.sort(sortByName),
        profile,
        hasOrganisations
      }
    }

    case `${ActionTypes.PROFILE_REQUEST}_FAIL`: {
      return {
        ...state,
        isRequesting: false
      }
    }

    case ActionTypes.SET_TOKEN: {
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.token
      }
    }

    default:
      return state
  }
}
